import { IonIcon } from '@ionic/react';
import clsx from 'clsx';
import Button from '../../../Button/Button';
import { FunctionalButtonConfig } from '../FunctionalButtonsRow';

interface CompactButtonsRowProps {
  buttons: FunctionalButtonConfig[];
  containerRef: React.RefObject<HTMLDivElement | null>;
}

const CompactButtonsRow = ({
  buttons,
  containerRef,
}: CompactButtonsRowProps) => (
  <div className="functional-row functional-row-compact" ref={containerRef}>
    <div className="functional-row-visible">
      {buttons.map((button) => (
        <Button
          key={button.key}
          id={button.id}
          dataAttributes={{ 'data-functional-key': button.key }}
          title={button.label}
          onClick={button.onClick}
          disabled={button.disabled}
          fill="clear"
          round={false}
          className={clsx(button.className, 'functional-icon-btn')}
        >
          <IonIcon icon={button.icon} />
        </Button>
      ))}
    </div>
  </div>
);

export default CompactButtonsRow;
